module.exports = __webpack_public_path__ + "static/media/copy.07f23e6a.svg";